import {
  modificationsRegex,
  figmaMetaDataRegex,
  apiSpecMethodRegex,
  apiSpecRegex,
  projectRulesRegex,
  globalRulesRegex,
} from '~/utils/diff';
import { Markdown } from './Markdown';

interface UserMessageProps {
  content: string;
  messagesLength?: number;
}

export function UserMessage({ content, messagesLength = 1 }: UserMessageProps) {
  return (
    <div className="overflow-hidden text-gray-100">
      <Markdown limitedMarkdown index={1} messagesLength={messagesLength}>
        {sanitizeUserMessage(content)}
      </Markdown>
    </div>
  );
}

function sanitizeUserMessage(content: string) {
  // remove the line starting with IMPORTANT:

  const data = content
    .replace(/^IMPORTANT:.*\n?/gm, '')
    .trim()
    .replace(modificationsRegex, '')
    .trim()
    .replace(figmaMetaDataRegex, '')
    .trim()
    .replace(apiSpecRegex, '')
    .trim()
    .replace(apiSpecMethodRegex, '')
    .trim()
    .replace(projectRulesRegex, '')
    .trim()
    .replace(globalRulesRegex, '')
    .trim();

  // console.log('[UserMessage] content: >>>> ', data, content);
  return data;
}
